import { Form, TextArea } from "@/components/Form"
import Button from "@/components/Button"
import AdminLayout from "@/components/Layout/Admin"
import { router } from "@inertiajs/react"
import { ReactNode } from "react"

const EditPage = ({ page, errors }) => {
  const { id } = page

  const handleSubmit = (page) => {
    router.put(`/admin/pages/${id}`, { page })
  }

  return (
    <Form defaultValues={page} errors={errors} onSubmit={handleSubmit}>
      <TextArea name="body" rows={20} />
      <Button>Save</Button>
    </Form>
  )
}

EditPage.layout = (page: ReactNode) => <AdminLayout children={page} />

export default EditPage
